module.exports = __webpack_public_path__ + "static/img/CHARLIE-BOVILL.9e9ba9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CHARLIE-BOVILL.jpg
// module id = JC/w
// module chunks = 0